export type TProgressMode =
  | { kind: 'notApplicable' }
  | { kind: 'calculating' }
  | { kind: 'complete' }
  | { kind: 'inProgress'; percent: number };

/** `calculating` without a percent; otherwise the percent rounded and clamped to `0..max`. */
export function toInProgressMode(
  progress: number | null | undefined,
  max = 100,
): Extract<TProgressMode, { kind: 'calculating' | 'inProgress' }> {
  if (progress === null || progress === undefined) {
    return { kind: 'calculating' };
  }

  return { kind: 'inProgress', percent: Math.max(0, Math.min(max, Math.round(progress))) };
}
